// Zapis niezapisanych zmian przed wylogowaniem (ponowny test odbiorczy 11.10.2026).
//
// Wylogowanie kasuje sesję i robi pełne przeładowanie na /login. Przy pełnym przeładowaniu React
// nie odmontowuje stron, więc zapis „przy wyjściu ze strony” (sprzątanie efektu) się nie wykonywał,
// a przeglądarka pytała o opuszczenie strony dopiero wtedy, gdy sesji już nie było: „Zostań”
// zostawiało stronę, której zapis i tak nie przejdzie.
//
// Strona z niezapisanymi zmianami rejestruje tu tę samą funkcję, którą woła przy wyjściu, a
// wylogowanie (utils/wyloguj.js) wykonuje je wszystkie PRZED usunięciem sesji, najwyżej przez
// chwilę, żeby zawieszony zapis nie blokował wylogowania. Funkcja zwraca obietnicę, gdy naprawdę
// coś zapisuje, a nic (undefined), gdy nie ma czego zapisać.

const zapisy = new Set();

// Przegląd bezpieczeństwa 12.10.2026: dawniej 3 s, a przez ten czas sesja jeszcze żyła, więc
// zamknięcie karty zaraz po „Wyloguj” zostawiało ją na serwerze. Teraz najwyżej 1,5 s, a karta
// zamknięta w trakcie i tak wysyła wylogowanie (utils/wyloguj.js, pagehide).
export const LIMIT_ZAPISU_PRZED_WYJSCIEM_MS = 1500;

// Wylogowanie właśnie przeładowuje stronę: strony z niezapisanymi zmianami NIE pytają już
// o jej opuszczenie (ich nasłuch beforeunload sprawdza trwaWylogowanie()). Sprawdzenie 12.10.2026:
// nasłuch wylogowania w fazie przechwytywania nie wystarczał, bo Chrome wywołuje nasłuchy
// zdarzenia wysłanego na window w kolejności rejestracji, więc strona pytała pierwsza, gdy jej
// zapis przed wylogowaniem się nie udał.
let poWylogowaniu = false;
export const oznaczWylogowanie = () => { poWylogowaniu = true; };
export const trwaWylogowanie = () => poWylogowaniu;
// Tylko dla testów: w aplikacji wylogowanie kończy się przeładowaniem strony, więc stan znika sam.
export const wyczyscStanWylogowania = () => { poWylogowaniu = false; };

// Konto zalogowane w tej przeglądarce (localStorage jest wspólny dla wszystkich kart). Zapis przy
// wyjściu i przed wylogowaniem idzie WYŁĄCZNIE, gdy to nadal konto z chwili otwarcia strony:
// po wylogowaniu i zalogowaniu na inne konto w innej karcie stara karta wysłałaby swój szablon
// z sesją nowego konta, czyli do jego firmy (przegląd bezpieczeństwa 12.10.2026).
export const kontoWKarcie = () => {
  try { return localStorage.getItem('userId'); } catch (_) { return null; }
};

export function zarejestrujZapisPrzedWyjsciem(zapisz) {
  zapisy.add(zapisz);
  return () => { zapisy.delete(zapisz); };
}

// `przyZapisie` jest wołane raz, gdy co najmniej jeden zapis naprawdę trwa (wylogowanie pokazuje
// wtedy nakładkę „Zapisuję zmiany i wylogowuję…”).
export async function zapiszPrzedWyjsciem({ limitMs = LIMIT_ZAPISU_PRZED_WYJSCIEM_MS, przyZapisie } = {}) {
  const trwajace = [];
  [...zapisy].forEach((zapisz) => {
    try {
      const wynik = zapisz();
      if (wynik && typeof wynik.then === 'function') trwajace.push(wynik);
    } catch (error) {
      console.error('Save before logout error:', error);
    }
  });
  if (trwajace.length === 0) return;
  if (przyZapisie) przyZapisie();
  let zegar = null;
  const limit = new Promise((resolve) => { zegar = setTimeout(resolve, limitMs); });
  try {
    await Promise.race([Promise.allSettled(trwajace), limit]);
  } finally {
    clearTimeout(zegar);
  }
}
